import images from "./images";

const About = {
    sub: "About Us",
    heading: "Discover the World with Altours",
    description: [
        "At Altours, we specialize in crafting unforgettable travel experiences, offering curated tours, exotic getaways, and seamless travel solutions for over two decades.",
        "Our mission is to inspire your wanderlust and deliver journeys that create lasting memories. Whether it’s a guided city tour or an adventure escape, we’re committed to providing exceptional service and unparalleled experiences tailored to your travel dreams."
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        alt1: "About-Image1",
        alt2: "About-Image2",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;